export const cartEventsConfig = {
    parentSelector: '#CartDrawer',
    events: {
        // Cart modal | close (CSV Line 126)
        cartModalClose: {
            selector: 'button.drawer__close', // Keep selector specific
            event: { // Wrap event details in an 'event' object
                event: 'cart_modal',
                component: 'cart_modal',
                element: 'modal',
                action: 'close',
                trigger: 'click' // Add the trigger type
            }
            // Removed the 'payload' structure as it's handled by 'event' now
        },
        // Cart modal | click on cta-button (view cart) (CSV Line 152 - part 1)
        cartModalViewCart: {
            selector: '#CartDrawer-ViewCart',
            event: { // Wrap event details
                event: 'cart_modal',
                component: 'cart_modal',
                element: 'cta_button',
                action: 'click',
                trigger: 'click', // Add trigger
                getDynamicData: (element) => ({ // Move getDynamicData inside event object
                    link_text: element.innerText?.trim(),
                    link_url: element.href, 
                })
            }
        },
        // Cart modal | click on cta-button (Afrekenen) (CSV Line 152 - part 2)
        cartModalCheckout: {
            selector: '#CartDrawer-Checkout',
            event: { // Wrap event details
                event: 'cart_modal',
                component: 'cart_modal',
                element: 'cta_button',
                action: 'click',
                trigger: 'click', // Add trigger
                getDynamicData: (element) => ({ // Move getDynamicData inside event object
                    click_text: element.innerText?.trim(), // Using click_text as per CSV
                })
            }
        },

        // == Quantity Adjustments ==

        // Cart modal | focus in number field (CSV Line 127)
        cartQuantityFocus: {
            selector: '.cart-item .quantity__input', // Target quantity input within a cart item
            event: {
                event: 'cart_modal',
                element: 'text_field', // Changed from 'number' to 'text_field' for consistency
                field: 'quantity',    // Explicitly set field name
                action: 'focus',
                trigger: 'focus',
                getDynamicData: (element) => {
                    const cartItem = element.closest('.cart-item');
                    const productNameElement = cartItem?.querySelector('.cart-item__name a, .cart-item__details a'); // Find product link
                    return {
                        component: productNameElement ? productNameElement.textContent.trim() : 'Unknown Product',
                    };
                }
            }
        },

        // Cart modal | input in number field (CSV Line 128)
        cartQuantityInput: {
            selector: '.cart-item .quantity__input',
            event: {
                event: 'cart_modal',
                element: 'text_field',
                field: 'quantity',
                action: 'input',
                trigger: 'input', // Debounced by datalayer.js
                getDynamicData: (element) => {
                    const cartItem = element.closest('.cart-item');
                    const productNameElement = cartItem?.querySelector('.cart-item__name a, .cart-item__details a');
                    return {
                        component: productNameElement ? productNameElement.textContent.trim() : 'Unknown Product',
                        input_value: element.value, // Use input_value as per CSV example structure
                    };
                }
            }
        },

        // Cart modal | click on arrow up (CSV Line 129)
        cartQuantityUp: {
            selector: '.cart-item .quantity__button[name="plus"]', // Target plus button
            event: {
                event: 'cart_modal',
                element: 'chevron',
                field: 'quantity',
                action: 'click',
                action_value: 'up', // Explicitly set action_value
                trigger: 'click',
                getDynamicData: (element) => {
                    const cartItem = element.closest('.cart-item');
                    const productNameElement = cartItem?.querySelector('.cart-item__name a, .cart-item__details a');
                    return {
                        component: productNameElement ? productNameElement.textContent.trim() : 'Unknown Product',
                    };
                }
            }
        },

        // Cart modal | click on arrow down (CSV Line 130)
        cartQuantityDown: {
            selector: '.cart-item .quantity__button[name="minus"]', // Target minus button
            event: {
                event: 'cart_modal',
                element: 'chevron',
                field: 'quantity',
                action: 'click',
                action_value: 'down', // Explicitly set action_value
                trigger: 'click',
                getDynamicData: (element) => {
                    const cartItem = element.closest('.cart-item');
                    const productNameElement = cartItem?.querySelector('.cart-item__name a, .cart-item__details a');
                    return {
                        component: productNameElement ? productNameElement.textContent.trim() : 'Unknown Product',
                    };
                }
            }
        },

        // == Product Removal ==

        // Cart modal | remove product (bin underneath product) (CSV Line 132)
        // Note: This might target the same element as above, or a different one.
        // Adjust selector if there's a distinct 'underneath' remove button.
        cartRemoveIconUnderneath: {
            selector: 'button.link.justify-right.align-center.tap-area-icon.por', // More general remove button selector
            event: {
                event: 'cart_modal',
                element: 'icon',
                // No 'field' specified in CSV for this one
                action: 'click',
                action_value: 'remove',
                trigger: 'click',
                getDynamicData: (element) => {
                    const cartItem = element.closest('.cart-item');
                    // Prevent double-firing if this selector accidentally matches the quantity one
                    if (element.closest('.cart-item__details')) return null; 
                    const productNameElement = cartItem?.querySelector('.cart-item__name a, .cart-item__details a');
                    return {
                        component: productNameElement ? productNameElement.textContent.trim() : 'Unknown Product',
                    };
                }
            }
        },

        // == Recommendations Slider ==

        // Cart modal | recommendations slider click on arrow > (CSV Line 133)
        cartRecommendationsNext: {
            // Assuming a common slider structure within the cart drawer
            selector: '#Slider-cart-drawer-product-recommendations-next-button', 
            event: {
                event: 'cart_modal',
                component: 'recommendation_slider',
                element: 'chevron',
                action: 'click',
                action_value: 'next',
                trigger: 'click'
            }
        },

        // Cart modal | recommendations slider click on arrow < (CSV Line 134)
        cartRecommendationsPrev: {
            selector: '#Slider-cart-drawer-product-recommendations-prev-button', 
            event: {
                event: 'cart_modal',
                component: 'recommendation_slider',
                element: 'chevron',
                action: 'click',
                action_value: 'previous',
                trigger: 'click'
            }
        },

        // Cart modal | recommendations slider click on product (CSV Line 135)
        cartRecommendationsCardClick: {
            selector: '.cart-item__name h6 link link--text font-heading-bold', // Link within recommendation card
            event: {
                event: 'cart_modal',
                component: 'recommendation_slider',
                element: 'card',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    // Check if click was on ATC button inside the card link area
                    if (element.closest('.quick-add__submit')) return null;
                    
                    const cardWrapper = element.closest('.card-wrapper');
                    const productName = element.textContent.trim(); // Product name from the clicked link
                    return {
                        product_name: productName,
                        link_url: element.href
                    };
                }
            }
        },

        // Cart modal | recommendations slider click on cta-button (CSV Line 136)
        cartRecommendationsATC: {
            selector: 'button.cart-drawer__recommendation-item__button', // Corrected selector targeting the button class
            event: {
                event: 'cart_modal',
                component: 'recommendation_slider',
                element: 'cta_button',
                action: 'click',
                action_value: 'add_to_cart', // Explicit from CSV structure
                trigger: 'click',
                getDynamicData: (element) => { // element is the matched button
                    const cardWrapper = element.closest('.card-wrapper'); // Assuming button is within a card-wrapper
                    const productNameElement = cardWrapper?.querySelector('.card__heading a'); // Assuming standard card heading link
                    const productName = productNameElement ? productNameElement.textContent.trim() : 'Unknown Product';
                    // Get text from the span inside the button
                    const buttonText = element.querySelector('span')?.textContent.trim() || 'Aan winkelwagen toevoegen';
                    return {
                        product_name: productName,
                        click_text: buttonText
                    };
                }
            }
        },

        // Cart modal | recommendations slider click on product (CSV Line 135)
        cartRecommendationsProductLinkClick: {
            selector: 'a.link.link--text', // Updated selector as per user input
            event: {
                event: 'cart_modal',
                component: 'recommendation_slider',
                element: 'card', // As per CSV
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => { // element is the <a> tag
                    // Prevent event if click was on an ATC button within the link's container
                    // Adjust parent selector for ATC if needed
                    if (element.closest('.quick-add__submit')) return null;

                    const productName = element.textContent.trim(); 
                    return {
                        product_name: productName,
                        link_url: element.href
                    };
                }
            }
        },

        // == Order Note Modal ==

        // Cart modal | Note modal | Open (CSV Line 137)
        cartNoteOpen: {
            selector: 'button.cart-drawer__footer__action-label', // Keep selector broad
            event: {
                event: 'cart_modal',
                component: 'note',
                element: 'modal',
                action: 'open',
                trigger: 'click',
                getDynamicData: (element) => { // Add condition check
                    const spanText = element.querySelector('span')?.textContent.trim();
                    // Only fire if the button text is 'Note'
                    return spanText === 'Note' ? {} : null; 
                }
            }
        },

        // Cart modal | Note modal | Close (CSV Line 138)
        cartNoteClose: {
            // Make selector specific to the note container
            selector: 'cart-drawer-note button.cart-drawer__footer__action-close', 
            event: {
                event: 'cart_modal',
                component: 'note',
                element: 'modal',
                action: 'close',
                trigger: 'click'
            }
        },

        // Cart modal | focus on note text field (CSV Line 139)
        cartNoteFocus: {
            selector: 'textarea#Cart-note.text-area.field__input', // Selector provided by user
            event: {
                event: 'cart_modal',
                component: 'note',
                element: 'text_field',
                action: 'focus',
                trigger: 'focus' // Trigger on focus event
                // No dynamic data needed
            }
        },

        // Cart modal | input in note text field (CSV Line 140)
        cartNoteInput: {
            selector: 'textarea#Cart-note.text-area.field__input', // Selector provided by user
            event: {
                event: 'cart_modal',
                component: 'note',
                element: 'text_field',
                action: 'input',
                trigger: 'input', // Trigger on input event (debounced by datalayer.js)
                getDynamicData: (element) => { // Add getDynamicData
                    return {
                        input_value: element.value // Capture the text area value
                    };
                }
            }
        },

        // Cart modal | click on cta-button note (CSV Line 141) - Now triggered by focus
        cartNoteApply: {
            // Using corrected and slightly scoped selector. Refine if needed.
            selector: '#CartDrawer button.button.button--primary',
            event: {
                event: 'cart_modal',
                component: 'note',
                element: 'cta_button',
                action: 'focus', // Changed action to focus
                trigger: 'focus', // Changed trigger to focus as requested
                getDynamicData: (element) => {
                    return {
                        // Capture button text, default to 'Apply' as per CSV example
                        click_text: element.textContent.trim() || 'Apply' // Keeping 'click_text' for consistency with CSV? Or change to 'focus_text'?
                    };
                }
            }
        },

        // == Shipping Calculator Modal ==

        // Cart modal | Shipping calculator modal | Open (CSV Line 142)
        cartShippingOpen: {
            selector: 'button.cart-drawer__footer__action-label', // Use broad selector
            event: {
                event: 'cart_modal',
                component: 'shipping_calculator', // From CSV
                element: 'modal',
                action: 'open',
                trigger: 'focus',
                getDynamicData: (element) => { // Add condition check
                    const spanText = element.querySelector('span')?.textContent.trim();
                    // Only fire if the button text is 'Shipping'
                    return spanText === 'Shipping' ? {} : null; 
                }
            }
        },

        // Cart modal | Shipping calculator modal | Close (CSV Line 143)
        cartShippingClose: {
            // Target close button within the specific shipping container
            selector: '.cart-drawer__footer__action-content--shipping-calculator button.cart-drawer__footer__action-close', 
            event: {
                event: 'cart_modal',
                component: 'shipping_calculator',
                element: 'modal',
                action: 'close',
                trigger: 'click'
            }
        },

        // Cart modal | shipping dropdown open (CSV Line 144)
        cartShippingDropdownOpen: {
            selector: 'select#AddressCountryCalculator.select__select', // Selector for the country dropdown
            event: {
                event: 'cart_modal',
                component: 'shipping_calculator',
                element: 'dropdown',
                action: 'open',
                trigger: 'click', // User clicks to reveal options
                getDynamicData: (element) => {
                    // Find the label associated with this select element
                    const label = document.querySelector(`label[for="${element.id}"]`);
                    return {
                        field_name: label ? label.textContent.trim() : 'Land/regio' // Get field name from label
                    };
                }
            }
        },

        // Cart modal | shipping dropdown select (CSV Line 146)
        cartShippingDropdownSelect: {
            selector: 'select#AddressCountryCalculator.select__select', // Target the country select element
            event: {
                event: 'cart_modal',
                component: 'shipping_calculator',
                element: 'dropdown',
                action: 'select',
                trigger: 'change', // Use 'change' event for select elements
                getDynamicData: (element) => {
                    const label = document.querySelector(`label[for="${element.id}"]`);
                    const selectedOption = element.options[element.selectedIndex];
                    return {
                        field_name: label ? label.textContent.trim() : 'Land/regio', 
                        select_value: selectedOption ? selectedOption.text : '' // Get text of the selected option
                    };
                }
            }
        },

        // Cart modal | shipping focus in text field (CSV Line 147)
        cartShippingFocus: {
            selector: 'input#AddressZipCalculator.field__input', // Target the postcode input
            event: {
                event: 'cart_modal',
                component: 'shipping_calculator',
                element: 'text_field',
                action: 'focus',
                trigger: 'focus', // Trigger on focus event
                getDynamicData: (element) => {
                    const label = document.querySelector(`label[for="${element.id}"]`);
                    return {
                        field_name: label ? label.textContent.trim() : 'Postcode' // Get field name from label
                    };
                }
            }
        },

        // Cart modal | shipping input in text field (CSV Line 148)
        cartShippingInput: {
            selector: 'input#AddressZipCalculator.field__input', // Target the postcode input
            event: {
                event: 'cart_modal',
                component: 'shipping_calculator',
                element: 'text_field',
                action: 'input',
                trigger: 'input', // Debounced by datalayer.js
                getDynamicData: (element) => {
                    const label = document.querySelector(`label[for="${element.id}"]`);
                    return {
                        field_name: label ? label.textContent.trim() : 'Postcode',
                        input_value: element.value // Capture the input value
                    };
                }
            }
        },
        // Cart modal | shipping click on cta-button (CSV Line 150)
        cartShippingCalculate: {
            // Be specific to the button within the shipping calculator
            selector: 'shipping-calculator button.button--secondary', 
            event: {
                event: 'cart_modal',
                component: 'shipping_calculator',
                element: 'cta_button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    return {
                        // Use text from button's span, default to 'Calculate'
                        click_text: element.querySelector('span')?.textContent.trim() || 'Calculate' 
                    };
                }
            }
        },

        // Cart modal | click on link in text (CSV Line 151)
        cartGenericLinkClick: {
            selector: '#CartDrawer a[href]', // Target any link with an href inside the drawer
            event: {
                event: 'cart_modal',
                component: 'cart_modal', // Keep component generic for these links
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    // Check if this link belongs to a more specific tracked interaction
                    // Add selectors for other handled links/buttons if necessary
                    if (element.closest('#CartDrawer-ViewCart, #CartDrawer-Checkout, .cart-item, .cart-recommendations .card-wrapper, .cart-drawer__footer__action-label, .cart-drawer__footer__action-close')) {
                         return null; // Suppress event if part of a more specific component
                    }
                    
                    // Ensure the link has meaningful text
                    const linkText = element.textContent.trim();
                    if (!linkText) {
                        return null; // Don't track clicks on links without text (e.g., image links)
                    }

                    return {
                        link_text: linkText,
                        link_url: element.href
                    };
                }
            }
        },

    },
};